// extracted by mini-css-extract-plugin
module.exports = {"fixtureSummaryBlockLeagueTable":"fixtureSummaryBlockLeagueTable_fixtureSummaryBlockLeagueTable__YEo7S"};